import {TranslationsManager} from '@vizir-banking/banking-app-core/dist/hooks/translations-manager';

export const registerThemeTranslations = (
  _translationsManager: typeof TranslationsManager,
): void => {};
